module.exports = "/_next/static/images/Hero@2x-797532c239dd47ed5d88cf49066eb4f3.webp";